<flowaccount-tax-invoice-intro></flowaccount-tax-invoice-intro>

<flowaccount-tax-invoice-banner-shared
  [contentList]="mockContent"
  [customClass]="'tax-invoice'"
></flowaccount-tax-invoice-banner-shared>

<flowaccount-tax-invoice-benefit></flowaccount-tax-invoice-benefit>

<flowaccount-tax-invoice-form></flowaccount-tax-invoice-form>

<flowaccount-mobile-documents
  [heading]="'TAX_INVOICE.MOBILE_DOCUMENTS.HEADING'"
  [contentDocuments]="contentDocuments"
></flowaccount-mobile-documents>

<flowaccount-tax-invoice-video></flowaccount-tax-invoice-video>

<flowaccount-faq-accordion-squidex
  [contentSquidex]="'taxinvoice-faq'"
  [contentScully]="'taxinvoice-faq-key'"
></flowaccount-faq-accordion-squidex>

<flowaccount-tax-invoice-join></flowaccount-tax-invoice-join>

<flowaccount-blog-swiper-squidex
  [customHeader]="customHeader"
  [lang]="translate.currentLang"
  [contentSquidex]="'taxinvoice-blog'"
  [contentScully]="'taxinvoice-blog-key'"
></flowaccount-blog-swiper-squidex>
